import { getAll} from "../../fetchs/get";
import { sessionEnd } from "../../redux/actions";

export default async function getDgfipData (
    forecastId : string | undefined,
    forecastVersion: number | undefined,
    setDgfipData : Function,
    token : string | undefined,
    dispatch : Function,
    setError : Function
) {
    if(token){
        getAll(token, '/forecast/'+forecastId+"/"+forecastVersion+'/dgfip', setDgfipData, 
            () => {
                dispatch(sessionEnd());
            }, setError
        )
    }
}